import { render, staticRenderFns } from "./HomeActivityNotice.vue?vue&type=template&id=a519ffc4&scoped=true&"
import script from "./HomeActivityNotice.vue?vue&type=script&lang=js&"
export * from "./HomeActivityNotice.vue?vue&type=script&lang=js&"
import style0 from "./HomeActivityNotice.vue?vue&type=style&index=0&id=a519ffc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a519ffc4",
  null
  
)

export default component.exports